import React from 'react';

interface LoadingBarProps {
  isLoading: boolean;
}

export const LoadingBar: React.FC<LoadingBarProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-1 overflow-hidden">
      <div
        className="h-full bg-gradient-to-r from-[#6b38d4] via-[#8455ef] to-[#6b38d4] animate-loading-bar"
        style={{ width: '40%' }}
      />
    </div>
  );
};
